import {
  createTagOverride,
  TextAppearance,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';

export const totalResultsTextOverrides: any = {
  div: createTagOverride(TextCustom, {
    appearance: TextAppearance.headline200,
    tag: TextTag.span,
    style: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight24,
      fontWeight: TextWeight.light,
    },
  }),
};
